import React, { useState, useEffect } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
const { getUrl } = Util;
import noDataImg from "@/assets/images/common/nodata.png";
import styles from "./index.module.less";

interface XtPaneProps {
  children?: React.ReactNode;
  minHeight?: number;
  isNeedLogin?: boolean;
  nodata?: boolean;
  loading?: boolean;
  className?: string;
}
const XtPane: React.FC<XtPaneProps> = ({ children, minHeight, isNeedLogin, nodata, loading, className }) => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const { theme, loginStatus } = appState;
  const isLogin = loginStatus == 1;
  const [loginQuery, setLoginQuery] = useState("");
  useEffect(() => {
    setLoginQuery("?backurl=" + encodeURIComponent(location.href));
  }, []);
  return (
    <div className={`${styles["xt-pane-container"]} ${styles["xt-pane-" + theme + "-container"]} ${className}`} style={{ minHeight: minHeight + "px" }}>
      {isNeedLogin && !isLogin ? (
        <div className={styles["pane-nologin"]} style={{ minHeight: minHeight + "px" }}>
          <span
            dangerouslySetInnerHTML={{ __html: t("home.htmlLogin", [getUrl("/accounts/login" + loginQuery), getUrl("/accounts/register" + loginQuery)]) }}
          ></span>
        </div>
      ) : nodata && !loading ? (
        <div className={styles["pane-nodata"]} style={{ minHeight: minHeight + "px" }}>
          <img src={noDataImg} alt="nodata" />
          <span>{t("home.noData")}</span>
        </div>
      ) : (
        children
      )}
    </div>
  );
};
export default XtPane;
